import "./projects.css"


function Project(){
    return(
        <>
        
        <div className="con">
        <h1 className="header">Our Projects</h1>
            <div className="container-1">
            
                <div className="card1">
                <h1>Commercial</h1>
                </div>
                <div className="card2">
                <h1>Residential</h1>
                </div>
                <div className="card3">
                <h1>Industry</h1>
                </div>
            </div>
        </div>
        </>
    )
}

export default Project;